import { Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { DataFetcherService } from '../../../services/data-fetcher/data-fetcher.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-source-info',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './source-info.component.html',
  styleUrl: './source-info.component.css'
})
export class SourceInfoComponent {
  newUrl: string = '';
  source: any;  // Array to store the list of sources
  sourceId: string | undefined; //Get the sourceId for API request

  constructor(private dataFetcher: DataFetcherService, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    // Access  the source ID from the route parameters
    this.route.params.subscribe(params => {
      this.sourceId = params['sourceId'];  // Workspace ID
      this.newUrl = this.router.url.toString().replace('/source/'+this.sourceId, '');
    });
    // Fetch the source data when the component initializes
    this.dataFetcher.GetSourceByIdData(this.sourceId).subscribe(
      (data: any) => {
        // Extract the 'sources' array from the data object
        this.source = data.sources[0] || null;  // Fallback to an empty array if 'sources' is undefined
      },
      (error) => {
        console.error('Error fetching source data', error);
      }
    );
    console.log(this.source);
  }

  getKeys(obj: object): string[] {
    return obj ? Object.keys(obj) : [];
  }
}

